module.exports = __webpack_public_path__ + "static/media/date_range.f069f439.svg";